import React from 'react';

const HorizontalList = props => {
    const { data, renderItem } = props;

    return (
        <div style={{
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap"
        }}>
            {data.map((item, index) => {
                return renderItem(item, index);
            })}
        </div>
    );
};

export default HorizontalList;